<template>
    <div class="content-height-full">
        <community-list
            :communities="communities"
            :statuses="statuses"
        />

        <prospect-map
            class="content-height-full"
            :prospects="[prospect]"
            :can-edit="false"
            :can-draw="true"
        />
        <a :href="route('admin.prospects.show', prospect)" class="btn btn-md is-ghost absolute pin-l pin-b mb-xl ml-5xl">
            Tillbaka
        </a>

        <adaptive-form-modal
            name="create-community"
            :callback="reload"
            primary-button-text="Skapa samfällighet"
            :action="route('admin.prospects.community.store', prospect)"
            @hide="clearUserCreatedShapes"
        >
            <input
                v-model="coordinates"
                type="hidden"
                name="polygon"
            >

            <text-input
                :required="true"
                :autofocus="true"
                name="name"
                label="Samfällighetens namn"
            />

            <text-input
                :required="true"
                name="information[number_of_households]"
                label="Antal hushåll"
            />

            <text-input
                :required="true"
                name="information[contact_name]"
                label="Namn på kontaktperson"
            />

            <text-input
                :required="true"
                name="information[contact_phone_number]"
                label="Telefon kontaktperson"
            />

            <text-input
                :required="true"
                name="information[contact_email]"
                label="E-post kontaktperson"
            />
        </adaptive-form-modal>

        <adaptive-modal
            v-if="selectedCommunity"
            name="community-info"
            :hide-action-buttons="true"
            :width="750"
            @hide="selectedCommunity = null"
        >
            <alert
                v-if="error"
                type="error"
                icon="fa-exclamation-circle"
                :initial-body="error"
            />

            <div class="overflow-x-auto">
                <table class="table condensed striped">
                    <tbody>
                        <tr>
                            <td>Samfällighet</td>
                            <td v-text="selectedCommunity.name" />
                        </tr>
                        <tr>
                            <td>
                                Antal hushåll
                            </td>
                            <td>
                                <span v-if="selectedCommunity.information">
                                    {{ selectedCommunity.information.number_of_households }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Namn på kontaktperson
                            </td>
                            <td>
                                <span v-if="selectedCommunity.information">
                                    {{ selectedCommunity.information.contact_name }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Telefon kontaktperson
                            </td>
                            <td>
                                <span v-if="selectedCommunity.information">
                                    {{ selectedCommunity.information.contact_phone_number }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td>E-post kontaktperson</td>
                            <td>
                                <span v-if="selectedCommunity.information">
                                    {{ selectedCommunity.information.contact_email }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="mt-lg flex justify-between">
                <a
                    :href="route('admin.prospects.community.edit', selectedCommunity)"
                    class="btn btn-md is-ghost"
                >
                    Redigera information
                </a>

                <a :href="route('admin.prospects.community.area.edit', selectedCommunity)" class="btn btn-md is-ghost">
                    Redigera områdesgräns
                </a>

                <status-changer
                    :available-statuses="statuses"
                    :current-status="selectedCommunity.status"
                    @changed="updateStatus"
                />
            </div>
        </adaptive-modal>
    </div>
</template>

<script>
    import CommunityList from '../Sidebars/CommunityList';
    import StatusChanger from '../../../../shared/components/Base/Forms/StatusChanger';

    export default {
        components: {
            CommunityList,
            StatusChanger,
        },
        props: {
            initialProspect: {
                type: Object,
                required: true,
            },
            center: {
                type: Object,
                default: () => {
                    return window.defaultMapCenter;
                },
            },
            statuses: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                error: null,
                initialLoad: true,
                mapLoaded: false,
                drawingInitialized: false,
                busy: false,
                prospect: null,
                coordinates: [],
                communities: [],
                selectedCommunity: null,
            };
        },
        computed: {
            zoomValue() {
                return parseInt(4);
            },
        },
        watch: {
            selectedCommunity() {
                Vue.nextTick(() => {
                    this.$modal.show('community-info');
                });
            },
        },
        created() {
            this.prospect = this.initialProspect;
            this.communities = this.prospect.communities;

            EventBus.$on(
                'shape-drawn',
                (polygon, shape) => {
                    this.coordinates = polygon;
                    this.drawnShape = shape;
                    this.$modal.show('create-community');
                },
            );

            EventBus.$on(
                'clicked-community',
                (communityId) => {
                    this.selectedCommunity = this.communities.find((community) => {
                        return community.id === communityId;
                    });
                },
            );
        },
        methods: {
            reload() {
                location.reload();
            },
            async updateStatus(status) {
                try {
                    const result = await axios.patch(
                        route('api.communities.status.update', this.selectedCommunity.id),
                        { status: status.key },
                    );

                    this.prospect = result.data;
                    this.communities = this.prospect.communities;
                    this.selectedCommunity = this.communities.find((community) => {
                        return community.id === this.selectedCommunity.id;
                    });

                    EventBus.$emit('repaint-prospect-map');
                } catch (error) {
                    this.error = 'Någonting gick fel när statusen skulle uppdateras, försök gärna igen.';
                }
            },
            clearUserCreatedShapes() {
                EventBus.$emit('clear-user-created-shapes', [this.drawnShape]);
            },
        },
    };
</script>